import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './theme/theme.css';
import './theme/components.css';
import { App } from './App.js';
import { ProfileApp } from './profile/ProfileApp.js';
import { ErrorBoundary } from './components/ErrorBoundary.js';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');

// Layout B — one app, two entry paths (no router dependency, so it builds on Node 18).
// `/profile` (or `/.proxy/profile`) = the Profile Activity; anything else = the review Activity.
// Both connect to Discord independently via useActivity().
// Split builds (Phase 1): the Profile app is built with VITE_APP=profile and renders the Profile
// Activity at root; the Review app renders ONLY the Review Activity (legacy /profile route retired).
// Each Discord app maps `/` to its own subdomain, so each launches only its own Activity.
const isProfile = import.meta.env.VITE_APP === 'profile';

createRoot(rootEl).render(
  <StrictMode>
    <ErrorBoundary>
      {isProfile ? <ProfileApp /> : <App />}
    </ErrorBoundary>
  </StrictMode>,
);
